<fieldset>
  <legend>General Configuration</legend>
  <div class="form-group">
    <label class=" control-label" for="">Name</label>
    <input (keyup)="NotifyListeners()" [(ngModel)]="name" class="form-control" required="" type="text" placeholder="project name">
  </div>
  <ng-container class="stateful req-online-only">
    <div class="form-group">
      <label class="control-label" for="">Default area</label>
      <select [(ngModel)]="area" class="form-control" (change)="SetArea(area)">
        <option  value="location">Address or named location</option>
        <option value="custom">Coordinates</option>
      </select>
    </div>
    <div #locSearchGrp class="loc-group stateful req-location form-group">
      <label class="control-label">Location Search: </label>
      <app-address-finder (selections)="HandleAddress($event)"></app-address-finder>
      <div class="invalid-feedback" *ngIf="searchFailed">Sorry, suggestions could not be loaded.</div>
    </div>
    <div class="stateful req-custom form-group">
      <label class="control-label" for="">GPS</label>
      <button (click)="GPS()" type="button" class="btn btn-primary" title="Center map on current location">
        <span class="fa fas fa-street-view"></span>
      </button>
      <!--ToDo Add gps icon via font awesome-->
      <div class="custom-control-description">Use the GPS button to detect your current location, or manually enter a
        new one.</div>
    </div>
    <div class="stateful req-custom form-group">
      <label class=" control-label" for="">Longitude</label>
      <input (change)="NotifyListeners()" [(ngModel)]="lng" data-dojo-attach-point="lon_input" class="form-control " required="" type="text"
        placeholder="longitude">
    </div>
    <div class="stateful req-custom form-group">
      <label class=" control-label" for="">Latitude</label>
      <input (change)="NotifyListeners()" [(ngModel)]="lat" class="form-control " required="" type="text" placeholder="latitude">
    </div>
    <div class="stateful req-custom form-group">
      <label class="control-label" for="">Level</label>
      <div class="">
        <select (change)="NotifyListeners()" [(ngModel)]="zoom" data-dojo-attach-point="zoom_sel" class="form-control ">
          <option value="-1">select a zoom level</option>
          <option value="1">1 - The Earth</option>
          <option value="2">2</option>
          <option value="3">3 - Continet</option>
          <option value="4">4 - Large Islands</option>
          <option value="5">5</option>
          <option value="6">6 - Large Rivers</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10 - Large Roads</option>
          <option value="11">11</option>
          <option value="12">12</option>
          <option value="13">13</option>
          <option value="14">14</option>
          <option value="15">15 - Buildings</option>
          <option value="16">16</option>
          <option value="17">17</option>
          <option value="18">18</option>
          <option value="19">19</option>
          <option value="20">20</option>
          <option value="21">21</option>
          <option value="22">21 - Fully zoomed in</option>
        </select>
      </div>
    </div>
  </ng-container>

</fieldset>
